export enum MediaType {
	Document = "D",
	Image = "I",
	Video = "V",
}

export enum MediaSizes {
	Large = "L",
	Medium = "M",
	Small = "S",
}

export type MediaFileRequest = {
	mediaCode: number;
	fileName: string;
};

export type HasPartialMediaResponse = {
	mediaCode: number;
	hasPartialMedia: boolean;
	mediaNumber: string | null;
	title: string | null;
};

export type MediaOptionsResponse = Record<string, unknown>;
